import React, { useState, useEffect } from "react";
import { Button, Spinner, Form } from "@themesberg/react-bootstrap";
import { ToastAlert } from "../../components/ToastAlert";
import API from "../../utils/api";
import { useTranslation } from "react-i18next";

const Feedback = () => {
  const [reviewText, setReviewText] = useState("");
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const { t } = useTranslation();

  const [alert, setAlert] = useState({ show: false, message: "", variant: "info" });
  const showAlert = (message, variant = "info") => setAlert({ show: true, message, variant });

  // Fetch current user
  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res = await API.get("/auth/me");
        setUser(res.data.user);
      } catch (err) {
        showAlert(t("alerts2.fetchUserError"), "danger");
      }
      setLoading(false);
    };
    fetchUser();
  }, [t]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user) return;

    setSubmitting(true); // Start spinner
    try {
      await API.post("/user-feedback", {
        reviewText,
        userName: user.name,
        userEmail: user.email,
      });
      showAlert(t("feedback2.submitSuccess"), "success");
      setReviewText("");
    } catch (err) {
      showAlert(t("feedback2.submitError"), "danger");
    }
    setSubmitting(false); // Stop spinner
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return (
    <div
      style={{
        maxWidth: "650px",
        margin: "50px auto",
        padding: "25px",
        borderRadius: "14px",
        backgroundColor: "#ffffff",
        boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
      }}
    >
      <ToastAlert
        show={alert.show}
        onClose={() => setAlert({ ...alert, show: false })}
        message={alert.message}
        variant={alert.variant}
      />

      <h4 style={{ textAlign: "center", marginBottom: "25px", fontWeight: "600", color: "#374151" }}>
        {t("feedback2.title")}
      </h4>

      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>{t("feedback2.label")}</Form.Label>
          <Form.Control
            as="textarea"
            rows={5}
            placeholder={t("feedback2.placeholder")}
            value={reviewText}
            onChange={(e) => setReviewText(e.target.value)}
            required
          />
        </Form.Group>

        <Button
          type="submit"
          size="md"
          className="w-100"
          style={{ backgroundColor: "#4f46e5", borderColor: "#4f46e5" }}
          disabled={submitting}
        >
          {submitting ? (
            <>
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                className="me-2"
              />
              {t("feedback2.submitting")}
            </>
          ) : (
            t("feedback2.submitButton")
          )}
        </Button>
      </Form>
    </div>
  );
};

export default Feedback;
